<template>
  <v-container fluid pa-0>
    <v-row align="center" justify="center" dense>
      <v-col cols="12" md="10">
        <v-card class="d-flex flex-row mt-5 mb-5 pa-5">
          <div class="ma-5"></div>
          <InputDate label="Date Du" @getDateVal="GetdateDu"></InputDate>
          <div class="ma-2"></div>
          <InputDate label="Date Au" @getDateVal="GetdateAu"></InputDate>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              mdi:microsoft-excel
              @click="Appliquer"
            >
              Appliquer
            </v-btn>
            <xlsx-workbook>
              <xlsx-sheet
                :collection="filteredData"
                sheet-name="Pointage Présence"
              />
              <xlsx-download>
                <v-btn dark color="green" @click="exportStatu = true">
                  Exporter
                  <v-icon right> mdi-microsoft-excel </v-icon>
                </v-btn>
              </xlsx-download>
            </xlsx-workbook>
          </v-card-actions>
        </v-card>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="Pointage"
            :search="search"
            @current-items="getFiltered"
            no-data-text="Pas de données disponibles ..."
            :items-per-page="exportStatu ? -1 : 10"
            :footer-props="{
              'items-per-page-text': 'Nombre de pointage par page',
            }"
          >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebaseApp from "../../firebase";
import InputDate from "../BaseComponents/InputDate.vue";
import moment from "moment";
import {
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "../../dist/vue-xlsx.es.js";

export default {
  components: {
    InputDate,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  mounted() {
    this.dateDu = this.today;
    this.dateAu = this.today;
    this.fetchData(this.dateDu, this.dateAu);
  },
  data() {
    return {
      exportStatu: false,
      dateDu: null,
      dateAu: null,
      isLoading: false,
      error: null,
      Pointage: [{}],
      search: "",
      filteredData: [],
      headers: [
        { text: "Date", value: "date", align: "start" },
        { text: "Site", value: "ferme" },
        { text: "Matricule", value: "chef" },
        { text: "Nom Prénom", value: "nomChef" },
        { text: "Véhicule", value: "véhicule" },
        { text: "Matricule", value: "matEmp" },
        { text: "Nom Prénom", value: "nomEmploye" },
        { text: "Heur", value: "heure_pointage" },
        { text: "Nature", value: "nature" },
      ],
    };
  },
  methods: {
    GetdateDu(val) {
      this.dateDu = val;
    },
    GetdateAu(val) {
      this.dateAu = val;
    },
    Appliquer() {
      if (this.diffDaysNumber < 0) {
        return alert("Period sectionnée in correct !");
      }
      this.fetchData(this.dateDu, this.dateAu);
    },
    getFiltered(e) {
      this.filteredData = e;
    },

    fetchData(dateDu, dateAu) {
      firebaseApp
        .ref("pointageEquipe")
        .orderByKey()
        .startAt(dateDu)
        .endAt(dateAu)
        .once("value")
        .then((snapshot) => {
          this.Pointage = [];
          snapshot.forEach((day) => {
            day.forEach((site) => {
              site.forEach((cap) => {
                cap.forEach((doc) => {
                  const point = doc.val();
                  this.Pointage.unshift({
                    date: point["datePointage"],
                    ferme: point["ferme"],
                    chef: point["chef"],
                    nomChef: point["nomChef"],
                    véhicule: point["véhicule"],
                    matEmp: point["matricule"],
                    nomEmploye: point["nomEmploye"],
                    heure_pointage: point["heure_pointage"],
                    nature: point["nature"],
                    compte: point["compte"],
                  });
                });
              });
            });
          });
        });
    },
  },
  computed: {
    itemsPerPage() {
      if (this.search !== "" && this.search !== null) {
        return -1;
      } else {
        return 10;
      }
    },
    diffDaysNumber() {
      return moment(this.dateAu, "YYYY-MM-DD").diff(
        moment(this.dateDu, "YYYY-MM-DD"),
        "days"
      );
    },
    today() {
      return moment().format("YYYY-MM-DD");
    },
  },
};
</script>
